package `fun`.adaptive.code.kotlin.writer.model

data class KwSymbol(
    val name : String
)